var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Accordion, styled } from "@mui/material";
export var Accordion2 = styled(function (props) { return (_jsx(Accordion, __assign({ disableGutters: true, elevation: 0, square: true }, props))); })(function (_a) {
    var theme = _a.theme;
    return ({
        border: "1px solid ".concat(theme.palette.divider),
        borderRadius: 0,
        "&:not(:last-child)": {
            borderBottom: 0,
        },
        "&::before": {
            display: "none",
        },
    });
});
